import { useMemo } from 'react';

import { usePublicQuizListPayload } from '@/module/public/hooks/useGetAllQuizesPayload';
import { omitSearchTextCriteria } from '@/module/public/util/publicQuizsetSearchPayload';

/**
 * 검색 입력 제안(카테고리 count/제목 자동완성)이 공유하는 필터 payload.
 *
 * 리스트 검색과 동일한 필터 소스를 사용하되, 아직 제출되지 않은 입력창의
 * 추천 결과가 현재 URL의 q 값에 묶이지 않도록 searchText/searchType만 제외한다.
 */
export const usePublicSuggestionFilterPayload = () => {
  const { categoryFilters, subjectFilter, enabled } =
    usePublicQuizListPayload();

  const suggestionCategoryFilters = useMemo(
    () => omitSearchTextCriteria(categoryFilters),
    [categoryFilters],
  );

  return {
    categoryFilters: suggestionCategoryFilters,
    subjectFilter,
    enabled,
  };
};
